type Key = `COLOR_${Uppercase<string>}`;
type Value = `#${string}`;
type Colors = Record<Key, Value>;

export const COLORS: Colors = {
  COLOR_000000: "#000000",
  COLOR_FFFFFF: "#ffffff",
};
